<template>
  <div class="clientGroup">
    <!-- MODAL - delete -->
    <md-dialog :md-active.sync="showDialog" v-if="brandToBeDeleted" @md-clicked-outside="onCancel">
      <md-dialog-title v-if="!title">
        <span>Brand delete</span>
        <button class="btn btn--close" @click="onCancel"></button>
      </md-dialog-title>
      <div class="confirm__content">
        <div class="text">Are you sure you want to delete the next:</div>
        <div><span class="client-name">{{ client.name }} /</span> <span
            class="brand-name">{{ brandToBeDeleted.name }}</span></div>
      </div>
      <md-dialog-actions>
        <div class="md-layout">
          <div class="md-layout-item">
            <md-button class="md-primary modal-cancel-btn" @click="onCancel">Cancel</md-button>
          </div>
          <div class="md-layout-item text-right">
            <md-button class="md-primary modal-delete-btn"
                       @click="deleteBrand(brandToBeDeleted.id); brandToBeDeleted=undefined;">Delete
            </md-button>
          </div>
        </div>
      </md-dialog-actions>
    </md-dialog>

    <!-- LEFT SIDE - logo, description -->
    <div class="clientGroup__left">
      <img v-if="client.logo" :srcset="client.logo.srcset"
           :src="CONFIG.apiUrl + client.logo.path + client.logo.file_name" :alt="client.name"/>
      <p v-if="accountView" v-html="nl2br(client.description)">
      </p>
    </div>

    <!-- RIGHT SIDE - brands, tables -->
    <div class="clientGroup__right">
      <div class="groupHeaderContainer">
        <div class="textTitle">{{ client.name }}</div>
        <div class="flex-row">
          <div class='buttonContainer'>
           
            <edit-client v-if="accountView && client.brand && $store.state.user.payment_type == '1' && $store.state.user.main_payment_cluster == client.payment_cluster_id"  :client="client" />
          </div>
          
          <add-new-brand v-if="accountView && client.brand && $store.state.user.payment_type == '1' && $store.state.user.main_payment_cluster == client.payment_cluster_id" :refreshClient="refreshClient" :client="client"
                         :btnclass="'btn btn-green buttonSizer btn-add-brand'"/>
        </div>
      </div>
      <md-divider class="divider"/>

      <add-new-brand class="hidden-add-new-button" :refreshClient="refreshClient" :client="client" v-if="accountView && !client.brand"
                     :btnclass="'btn btn-green buttonSizer btn-add-brand'"/>
      <!-- BRANDS TABLE -->
      <div v-if="client.brand" class="underline clientGroup__right-content-tbl">
        <table>
          <thead>
          <tr>
            <th class="tb-icon"></th>
            <th class="tb-name tb-name-style">Brand name</th>
            <th class="tb-campaigns">Campaigns</th>
            <th class="th-buttons"></th>
          </tr>
          </thead>
          <tbody>
          <tr class="separate-cell" style v-for="(brand, brandindex) in client.brand" :key="brand.id">
            <td class="tb-icon" >
              <div class="tb-icon-wrap" v-if="brand.logo">
                <!-- <img :srcset="brand.logo.srcset"
                     :src="CONFIG.apiUrl + brand.logo.path + brand.logo.file_name" 
                     :alt="brand.name"        
                     :id="'tb-icon-'+ brandindex"            
                     @load="imgType('tb-icon-'+ brandindex)" 
                /> -->
                <img :srcset="brand.logo.srcset"
                     :src="CONFIG.apiUrl + brand.logo.path + brand.logo.file_name" 
                     :alt="brand.name"        
                     :id="'tb-icon-'+ brandindex"                                 
                />
              </div>
            </td>
            <td class="tb-name">
              <strong>{{ brand.name }}</strong>
            </td>
            <td class="tb-campaigns">
              <span>{{ (brand.campaign) ? brand.campaign.length : 0 }}</span>
            </td>

            <td class="tb-buttons">
              <edit-brand :client="brand.client" :brand="brand" v-if="accountView"/>
              <button class="btn btn-icon" @click="brandToBeDeleted = brand; showDialog=true" v-if="accountView">
                <img alt="Delete Button" class="deleteButton" src="@/assets/icons/delete.svg"/>
              </button>
              <router-link :to="'/brand/'+brand.slug">
                <button onclick="window.location='#/brand'" class="btn btn-blue">
                  <span>OPEN</span>
                </button>
              </router-link>
            </td>
          </tr>
          </tbody>
          <!--          <tbody v-if="client.brand" >-->
          <!--            <tr><td colspan="4" class="empty-data">No results.</td></tr>-->
          <!--          </tbody>-->
        </table>
      </div>

      <!-- TIMELINE -->
      <div class="action-table">
        <Actions v-if="client.brand" :timeline="timeline"/>
      </div>
    </div>
  </div>
</template>

<script>
import Actions from "@/components/pagesComponents/dashboard/Actions.vue"
import AddNewBrand from "@/components/pagesComponents/dashboard/addNewBrand";
import EditBrand from "@/components/pagesComponents/dashboard/editBrand";
import EditClient from "@/components/pagesComponents/client/editClient";
//import LinkCopier from '@/components/LinkCopier'
import apiHandlerMI from "@/mixins/apiHandlerMI";

export default {
  props: ['client', 'timeline', 'accountView', 'refreshClient', 'title'],
  data() {
    return {
      showDialog: false,
      brandToBeDeleted: undefined,
      // value: null,      
    }
  },
  mixins: [apiHandlerMI],
  components: {
    EditClient,
    EditBrand,
    AddNewBrand,
    Actions,
    //LinkCopier
  },  
  methods: {
    onCancel() {
      // this.value = 'Disagreed'
      this.showDialog = false
      this.brandToBeDeleted = undefined
    },
    deleteBrand(id) {
      const _this = this;
      this.delete(`brand/${id}`, {}, () => {
        _this.refreshClient();
        _this.showDialog = false
      }, () => {
        //console.log('Sikertelen Torles');        
      });
    },
    setRefreshClient() {
      console.log('setRefreshclient')
      let _this = this
      _this.refreshClient();
    },
    // imgType(image){
    //   var imageId = document.getElementById(image)
    //   var imageWidth = imageId.width
    //   var imageHeight = imageId.height      

    //   if (imageWidth && imageHeight) {
    //     if (imageWidth === imageHeight) {          
    //       imageId.classList.add('square')
    //     } else if (imageHeight > imageWidth) {          
    //       imageId.classList.add('portrait')
    //     } else {          
    //       imageId.classList.add('rectangle')
    //     }
    //   }
    // }
  }
}
</script>

<style scoped>
.clientGroup__right .underline {
  margin: 0;
  width: 100%;
  max-width: 100%;
}
</style>